module.exports = __webpack_public_path__ + "static/img/wpp1bg.dfd859e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp1bg.png
// module id = MURo
// module chunks = 2